<template>
  <modal v-if="moreInfo" @close="moreInfo = false" :auto="moreInfo.product_type === 'airportlounge'">
    <div slot="header"></div>
    <slot slot="body" v-if="moreInfo.product_type === 'airportparking'">
      <modal-header />
      <tabs :cache-lifetime="0" :options="{ useUrlFragment: false }">
        <tab :name="$t('more_info.tabs.summary')">
          <summary-tab />
        </tab>
        <tab :name="$t('more_info.tabs.on_arrival')">
          <arrival-tab />
        </tab>
        <tab :name="$t('more_info.tabs.on_return')">
          <return-tab />
        </tab>
        <tab :name="$t('more_info.tabs.important')">
          <important-tab />
        </tab>
        <tab @clicked="map = true" :name="$t('more_info.tabs.map')">
          <map-tab v-if="!map"/>
        </tab>
        <tab :name="$t('more_info.tabs.reviews')" v-if="moreInfo.reevoo_reviews">
          <reviews-tab />
        </tab>
      </tabs>
    </slot>
    <slot slot="body" v-else-if="moreInfo.product_type === 'airporthotel'">
      <modal-header />
      <tabs :cache-lifetime="0" :options="{ useUrlFragment: false }">
        <tab :name="$t('more_info.tabs.overview')">
          <hotel-overview-tab />
        </tab>
        <tab :name="$t('more_info.tabs.full_information')">
          <hotel-information-tab />
        </tab>
        <tab @clicked="map = true" :name="$t('more_info.tabs.map')">
          <map-tab v-if="!map"/>
        </tab>
      </tabs>
    </slot>
    <slot slot="body" v-else-if="moreInfo.product_type === 'airportlounge'">
      <modal-header />
      <tabs :cache-lifetime="0" :options="{ useUrlFragment: false }">
        <tab :name="$t('more_info.tabs.overview')">
          <lounge-overview-tab />
        </tab>
        <tab :name="$t('more_info.facilities')">
          <lounge-information-tab />
        </tab>
      </tabs>
    </slot>
  </modal>
</template>

<script>
import { sync } from "vuex-pathify";
import mixins from "@/mixins"

import { Tabs, Tab } from "vue-tabs-component";
import { Modal, ReturnTab, SummaryTab, ArrivalTab, ImportantTab, MapTab, ReviewsTab, HotelOverviewTab, HotelInformationTab, LoungeInformationTab, LoungeOverviewTab } from "@/components";
import ModalHeader from "./more-info/header";

export default {
  name: "more-info",
  mixins: [mixins.format],
  components: { Modal, Tab, Tabs, SummaryTab, ModalHeader, ArrivalTab, ReturnTab, ImportantTab, MapTab, ReviewsTab, HotelOverviewTab, HotelInformationTab, LoungeInformationTab, LoungeOverviewTab },
  data() {
    return {
      map: false,
    }
  },
  computed: {
    moreInfo: sync("modals/moreInfo")
  },
  methods: {
    areScrollbarsVisible() {
      let scrollableElem = document.createElement('div'), innerElem = document.createElement('div');
        scrollableElem.style.width = '30px';
        scrollableElem.style.height = '30px';
        scrollableElem.style.overflow = 'scroll';
        scrollableElem.style.borderWidth = '0';
        innerElem.style.width = '30px';
        innerElem.style.height = '60px';
        scrollableElem.appendChild(innerElem);
        document.body.appendChild(scrollableElem);
        let diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
        document.body.removeChild(scrollableElem);
        return diff > 0;
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      // Show scrollbars if they're hidden.
      if (!this.areScrollbarsVisible()) {
        document.body.classList.add('force-show-scrollbars');
      }
    })
  }
};
</script>